// Lance (ou relance) l'analyse TURPE COMPLÈTE d'un PDL, côté serveur : POST /api/turpe/relancer-analyse
// (backend services/relanceAnalyseTurpe.service.js) — analyse de base ET son verdict
// (turpe_analyses, là où la page lit « concluante / non concluante / non vérifiée »),
// réinitialisation des résultats et du choix final antérieurs, optimisation des puissances,
// version d'utilisation, sauvegardes. Le script de relance en masse
// (backend/scripts/relance-analyses-turpe.js) passe par le même service.
// Avant le 24/10/2026, les panneaux ne relançaient que les optimisations : l'analyse de base,
// son verdict et le choix final antérieur restaient (LE BAO BAR, relance de 05:15 UTC).
import { lireReponseApi } from './reponseApiTurpe';

/**
 * @param {{ pdlId: string, annee: number, session: object, onEtape?: (texte: string) => void }} p
 * @returns {Promise<{ avertissements: string[], conclusion: object|null }>}
 */
export async function relancerAnalyseTurpe({ pdlId, annee, session, onEtape = () => {} }) {
  onEtape('Relance complète : analyse de base, puissances, version d\'utilisation…');
  const corps = await lireReponseApi(await fetch('/api/turpe/relancer-analyse', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session?.access_token}` },
    body: JSON.stringify({ pdl_id: pdlId, analysis_year: annee }),
  }), "Relance de l'analyse");
  return {
    avertissements: Array.isArray(corps?.data?.avertissements) ? corps.data.avertissements : [],
    conclusion: corps?.data?.conclusion || null,
  };
}
